import React from 'react';
import { connect } from 'react-redux';

import { selectNotifications } from 'src/core/redux/selectors';
import { removeNotification } from 'src/core/redux/actions/sync';

import NotificationsComponent from './NotificationsComponent';

const NotificationsContainer = (props) => <NotificationsComponent {...props} />;

const mapStateToProps = (state) => ({
  notifications: selectNotifications(state)
});

const mapDispatchToProps = {
  removeNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsContainer);
